import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import camelCaseKeys from 'utils/camelCaseKeys'
import {
  set as setSearch
} from 'store/redux/search'

export default function * fetchSearchCards (action) {
  const { refresh, boardId, limit } = action.payload

  if (refresh) {
    yield put(setSearch({
      cards: [],
      cardsCursor: null,
      cardsTotalCount: null,
      cardsLoadedAll: false,
      cardsLoading: true
    }))
  } else {
    yield put(setSearch({
      cardsLoading: true
    }))
  }

  const state = yield select()

  const { query, limitToBoard, refiners, cards, cardsCursor, cardsSort } = state.kanbo.search

  try {
    const { Results, Cursor, Refiners, SortOptions, TotalRows } = yield call(apiGetData, 'SearchCards', {
      query,
      cursor: cardsCursor,
      limit,
      sort: cardsSort,
      boardIds: (boardId && limitToBoard) ? [boardId] : undefined,
      refiners: Object.keys(refiners.cards).map(key => ({
        id: key,
        ...refiners.cards[key]
      })),
    })

    yield put(setSearch({
      cards: [
        ...cards,
        ...Results.map(Result => ({
          id: Result.Card.Id,
          name: Result.Card.Name,
          responsible: Result.Card.Users.filter(User => User.IsResponsible).map(User => User.Id)[0] || null,
          users: Result.Card.Users.filter(User => !User.IsResponsible).map(User => User.Id),
          isArchived: Result.Card.IsArchived,
          boardId: Result.BoardId,
          boardName: Result.BoardName,
          listId: Result.ListId,
          listName: Result.ListName,
          highlight: Result.Highlight && {
            html: Result.Highlight.HighlightHtml,
            type: Result.Highlight.Type
          }
        }))
      ],
      cardsCursor: Cursor,
      cardsRefiners: Refiners ? camelCaseKeys(Refiners) : [],
      cardsSortOptions: SortOptions ? camelCaseKeys(SortOptions) : [],
      cardsTotalCount: TotalRows,
      cardsLoadedAll: !Cursor,
      cardsLoading: false,
    }))
  } catch (error) {
    yield put(setSearch({
      cardsLoading: false
    }))

    throw error
  }
}
